module.exports = __webpack_public_path__ + "img/fufei.42159b70.svg";